import api from '../token';

export const AlterProduto = async (payload) => {
  try {
    const response = await api.post('/update',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

